<template>
    <div class="header" id="header">
        <div class="content">
            <b-navbar toggleable="lg" type="light">
                <b-navbar-brand href="#" to="/"> 
                    <img src="../assets/img/img_logo.svg" alt="Logo"> 
                </b-navbar-brand>

                <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>

                <b-collapse id="nav-collapse" is-nav>
                    <b-navbar-nav class="ml-auto">
                        <b-nav-item v-if="lang == 'eng'" :to="inicio">Home</b-nav-item>
                        <b-nav-item v-else-if="lang == 'esp'" to="/">Inicio</b-nav-item>

                        <b-nav-item v-if="lang == 'eng'" to="/Nosotros">About Us</b-nav-item>
                        <b-nav-item v-else-if="lang == 'esp'" to="/Nosotros">Nosotros</b-nav-item>
                        
                        <b-nav-item v-if="lang == 'eng'" :to="{name: 'Home', hash: '#beneficios'}">Benefits</b-nav-item>
                        <b-nav-item v-else-if="lang == 'esp'" :to="{name: 'Home', hash: '#beneficios'}">Beneficios</b-nav-item>
                        
                        <b-nav-item v-if="lang == 'eng'" :to="{name: 'Home', hash: '#ubicaciones'}">Locations</b-nav-item>
                        <b-nav-item v-else-if="lang == 'esp'" :to="{name: 'Home', hash: '#ubicaciones'}">Ubicaciones</b-nav-item>

                        <b-nav-item v-if="lang == 'eng'" :to="{name: 'Home', hash: '#preguntas'}">FAQ</b-nav-item>
                        <b-nav-item v-else-if="lang == 'esp'" :to="{name: 'Home', hash: '#preguntas'}">Preguntas</b-nav-item>

                        <b-nav-item v-if="lang == 'eng'" :to="{name: 'Home', hash: '#noticias'}">Notices</b-nav-item>
                        <b-nav-item v-else-if="lang == 'esp'" :to="{name: 'Home', hash: '#noticias'}">Noticias</b-nav-item>

                        <b-nav-item href="https://www.facebook.com/Border-Comercial-2322539974643327/" target="_blank" class="redes"><img src="../assets/img/icn_facebook.svg" alt="Facebook"></b-nav-item>
                        <!-- <b-nav-item href="#" class="redes"><img src="../assets/img/icn_instagram.svg" alt="Instagram"></b-nav-item>
                        <b-nav-item href="#" class="redes"><img src="../assets/img/icn_youtube.svg" alt="Youtube"></b-nav-item> -->
                        
                        <b-nav-item  @click="newLang()" class="lang"><img src="../assets/img/icn_lenguaje.svg" alt="Lang"> <span>{{textLang}}</span></b-nav-item>
                    </b-navbar-nav>
                </b-collapse>
            </b-navbar>
        </div>
    </div>
</template>

<script>
    import {mapState, mapActions, mapMutations} from 'vuex'
    export default {
        computed:{
            ...mapState(['lang'])
        },
        mounted(){
            window.onscroll = () => {
                var windowHeight = window.scrollY

                var banner = document.querySelector('#banner').offsetTop
                if(windowHeight >= banner  ){
                    const header = document.querySelector('#header')
                    header.className = 'header scroll'
                }else{
                    const header = document.querySelector('#header')
                    header.className = 'header'
                }
            }
            this.home()
        },
        data() {
            return {
                textLang: '',
                inicio: ''
            }
        },
        watch: {
            lang(newVal, oldVal){
                if(newVal == 'eng'){
                    this.textLang = 'ESP'
                }
                else if(newVal == 'esp'){
                    this.textLang = 'ENG'
                }
            },
            $route(){
                this.home()
            }
        },
        methods:{
            ...mapMutations(['updateLang']),
            newLang() {
                if(this.lang == "eng"){
                     this.updateLang('esp')
                }
                else if(this.lang == "esp"){
                     this.updateLang('eng')
                }
            },
            home(){
                if(this.$route.name == "Home"){
                    this.inicio = {name: 'Home', hash: '#home'}
                }
                else{
                    this.inicio = '/'
                }
            }
        }
    }
</script>

<style scoped>
    *{
        font-size: 11pt!important;
    }
    .header{
        background-color: #EF4E28;
        position: fixed;
        width: 100%;
        z-index: 999;
    }
    .scroll{
        -webkit-box-shadow: 0px 10px 25px 0px rgba(239,78,40,1);
        -moz-box-shadow: 0px 10px 25px 0px rgba(239,78,40,1);
        box-shadow: 0px 10px 25px 0px rgba(239,78,40,1);
    }
    .content{
        width: 92.5%;
        margin: 0 0 0 auto;
    }
    .navbar-brand img{
        width: 90px;
    }
    .nav-item{
        display: flex;
        align-items: center;
        margin-left: 10px;
    }
    .navbar-light .navbar-nav .nav-link{
        color: white!important;
    }
    .redes img{
        width: 80%;
    }
    .lang img{
        width: 16px;
        vertical-align: middle;
    }
    .lang span{
        font-family: 'sailecBold';
    }
    
    @media screen and (max-width: 991px){
        .navbar{
            padding: 3px 0;
        }
        .navbar-brand img{
            width: 55px;
        }
        .content{
            width: 90%;
            margin: 0 auto;
        }
    }
</style>

<style>
    .navbar-light .navbar-toggler{
        padding: 0;
        border: none;
        outline: none!important;
    }
    .navbar-toggler-icon{
        width: 2em!important;
    }
    .navbar-light .navbar-toggler-icon{
        background-image: url('../assets/img/icn_menu.svg')!important;
    }
</style>



// WEBPACK FOOTER //
// src/components/Header.vue